
import { useNavigate } from "react-router-dom"
import styled from "styled-components"

const Footer = () => {

    const navigate = useNavigate()

    return(
        <>
            <FooterContainer>
                <FooterLeft>
                    <SocialsText as='a' href="https://facebook.com">Facebook</SocialsText>
                    <SocialsText as='a' href="https://instagram.com/cook2c9_">Instagram</SocialsText>
                </FooterLeft>
                <FooterMiddle>
                    <CopyrightText>Copyright Connor Cook @ 2026</CopyrightText>
                </FooterMiddle>
                <FooterRight>
                    <FooterNav as='a' href="https://linkedin.com/in/cookconnor">LinkedIn</FooterNav>
                    <FooterNav onClick={() => navigate('/')}>Return Home</FooterNav>
                    {/* <FooterNav onClick={() => navigate('/blogpage')}>Blog Page</FooterNav>
                    <FooterNav as='a' href="mailto:cookconnor55@gmail.com">Email Me</FooterNav> */}
                </FooterRight>
            </FooterContainer>
        </>
    )
}

const FooterContainer = styled.div`
    background-color: #0D47A1;
    height: 15vh;
    display: flex;
    flex-direction: row;
    color: #E3F2FD;
    
`

const FooterLeft = styled.div`
    height: 100%;
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
`

const SocialsText = styled.p`
    margin: 0 0 0 5%;
    display: inline-block;
    width: 17%;
    text-decoration: none;
    color: inherit;

    &:visited{
        color: inherit;
    }

    &:hover{
        color: #2196F3;
    }
`

const FooterMiddle = styled.div`
    height: 100%;
    width: 40%;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
`

const CopyrightText = styled.p`
    
`

const FooterRight = styled.div`
    height: 100%;
    width: 30%;
    text-align: right;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    gap: 8px;
`

const FooterNav = styled.button`
    text-decoration: none;
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    font: inherit;
    cursor: pointer;
    color: #E3F2FD;
    margin-right: 5%;
    &:hover{
        color: #2196F3;
    }
`

export default Footer